export enum CommonStatus {
    Active = 1,
    InActive = -1
}